var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.item.classes},[_c('a',{attrs:{"href":_vm.item.link.url,"target":_vm.item.link_internal ? '' : '_blank'}},[_c('img',{attrs:{"src":_vm.item.image.filename,"alt":_vm.item.image.alt}})])])}
var staticRenderFns = []

export { render, staticRenderFns }